



































































import { Component, Mixins, Prop, Emit, Ref } from "vue-property-decorator";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import { VForm } from "@/types";

@Component
export default class extends Mixins(AxiosMixin, RulesMixin) {
  /** ダイアログ開閉状態 */
  @Prop({ default: false }) private readonly value!: boolean;

  /** フォーム操作用 */
  @Ref("form") protected readonly form!: VForm;

  /** 契約ID */
  @Prop({ default: 0 }) private agreementId!: number;

  @Emit() private input(value: boolean) {
    return value;
  }

  private get Value() {
    return this.value;
  }
  private set Value(value: boolean) {
    this.input(value);
  }

  /** 職員名前（姓） */
  private lastName = "";
  /** 職員名前（名） */
  private firstName = "";
  /** 職員名前（姓ふりがな） */
  private lastNameKana = "";
  /** 職員名前（名ふりがな） */
  private firstNameKana = "";

  /** 本社職員作成 */
  private async createStaff() {
    if (!this.form.validate()) {
      await this.$openAlert("入力内容に不備があります。");
      return;
    }

    if (!(await this.$openConfirm("本社職員を追加しますか？"))) {
      return;
    }

    this.postJsonBlobResCheck(
      window.base_url + "/api/admin/agreement/staff/create",
      {
        agreement_id: this.agreementId,
        last_name: this.lastName,
        first_name: this.firstName,
        last_name_kana: this.lastNameKana,
        first_name_kana: this.firstNameKana,
      },
      async () => {
        await this.$openAlert("作成が完了しました。");
        this.cancel();
      }
    );
  }

  /** ダイアログキャンセル */
  private cancel() {
    this.Value = false;
    this.lastName = "";
    this.firstName = "";
    this.lastNameKana = "";
    this.firstNameKana = "";
    this.form.resetValidation();
  }
}
